// extracted by mini-css-extract-plugin
export default {"root":"all-users_root__tfMin","header_container":"all-users_header_container__pq9XR"};